// import Index from './index.vue'
// import List from './components/List.vue'
// import DeletedInvoice from './components/DeletedInvoice.vue'
// import Create from './components/Create.vue'
// import Edit from './components/Edit.vue'
// import Home from './view/Home.vue'
// import AdjustCost from './components/AdjustCost.vue'

const Index = () => import( /* webpackChunkName: "invoice" */ './index.vue');
const List = () => import( /* webpackChunkName: "invoice" */ './components/List.vue');
const DeletedInvoice = () => import( /* webpackChunkName: "invoice" */ './components/DeletedInvoice.vue');
const Create = () => import( /* webpackChunkName: "invoice" */ './components/Create.vue');
const Edit = () => import( /* webpackChunkName: "invoice" */ './components/Edit.vue');
const Home = () => import( /* webpackChunkName: "invoice" */ './view/Home.vue');



export default [{
  path: '/subscription',
  name: 'subscription',
  component: Index,
  redirect: {
    name: 'subscription-home'
  },
  title: 'Subscription',
  children: [{
      path: 'home',
      name: 'subscription-home',
      component: Home,
    },
    {
      path: 'list',
      name: 'subscription-list',
      component: List,
    },
    {
      path: 'deleted',
      name: 'deleted-subscription-list',
      component: DeletedInvoice,
    },
    {
      path: 'create',
      name: 'subscription-create',
      component: Create,
      props: true,
    },
    {
      path: ':id/edit',
      name: 'subscription-edit',
      component: Edit,
    },
  ],
}, ]